export enum StreamStatus {
    PROGRESS_WITHOUT_DATA = 'PROGRESS_WITHOUT_DATA',
    PROCESSING = 'PROCESSING',
    FINISH = 'FINISH',
    ABORTED = 'ABORTED'
}
